import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ForYouSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-312">
      <div className="max-w-lg md:max-w-4xl mx-auto" data-id="element-313">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-314">
          {/* Not for you */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#FFEBEE] p-8 rounded-3xl border border-[#FFCDD2]" data-id="element-315">
            <div className="flex items-center gap-3 mb-6" data-id="element-316">
              <div className="bg-[#EF5350] p-2 rounded-full text-white" data-id="element-317">
                <X className="w-6 h-6" data-id="element-318" />
              </div>
              <h3 className="text-xl font-bold text-[#C62828]" data-id="element-319">
                ESTO NO ES PARA TI SI…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-320">
              {['Buscas una solución perfecta que funcione el primer día', 'Esperas que tu hijo coma todo inmediatamente', 'No estás dispuesta a aplicar el sistema aunque sea de forma imperfecta'].map((item, idx) => <li key={idx} className="flex gap-3 text-[#B71C1C]" data-id="element-321">
                  <span className="shrink-0 mt-1 opacity-70" data-id="element-322">
                    <X className="w-4 h-4" data-id="element-323" />
                  </span>
                  <span data-id="element-324">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* For you */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#E8F5E9] p-8 rounded-3xl border border-[#C8E6C9]" data-id="element-325">
            <div className="flex items-center gap-3 mb-6" data-id="element-326">
              <div className="bg-[#4CAF50] p-2 rounded-full text-white" data-id="element-327">
                <Check className="w-6 h-6" data-id="element-328" />
              </div>
              <h3 className="text-xl font-bold text-[#2E7D32]" data-id="element-329">
                ESTO ES EXACTAMENTE PARA TI SI…
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-330">
              {['Quieres dejar de improvisar y tener un sistema real', 'Tu hijo rechaza alimentos y no sabes cómo manejarlo sin peleas', 'Quieres ofrecer comida más nutritiva pero no tienes horas libres', 'Sientes culpa en la mesa y quieres cambiar eso', 'Necesitas recetas que los niños realmente coman'].map((item, idx) => <li key={idx} className="flex gap-3 text-[#1B5E20]" data-id="element-331">
                  <span className="shrink-0 mt-1" data-id="element-332">
                    <Check className="w-5 h-5 text-[#4CAF50]" data-id="element-333" />
                  </span>
                  <span className="font-medium" data-id="element-334">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}